module.exports = __webpack_public_path__ + "img/background-study-facility-name.13397d57.jpg";